function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Mobility"
}, /*#__PURE__*/React.createElement("title", null, "VF_mobility_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M239.4 67.9c-7.8-15.6-23.7-25.4-41.1-25.4H85.2c-17.4 0-33.4 9.9-41.1 25.5l-22.8 45.3v127.5h49.6v-28.3h141.7v28.3h49.6V113.6l-22.8-45.7zM49.6 127.6h184.3v56.7H49.6v-56.7zm19.8-46.9c3-6.1 9-9.8 15.7-9.8h113.2c6.7 0 12.7 3.7 15.7 9.7l9.3 18.6H60.1l9.3-18.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M92.1 141.7H63.8v14.2c0 7.8 6.3 14.2 14.2 14.2h28.3v-14.2c0-7.8-6.3-14.2-14.2-14.2zM177.2 155.9v14.2h28.3c7.8 0 14.2-6.3 14.2-14.2v-14.2h-28.3c-7.9 0-14.2 6.4-14.2 14.2z"
}))));